module.exports = __webpack_public_path__ + "angelisland.ogg?ee186a6adcd4a33942129f0076a7fd58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/angelisland.ogg
// module id = 12
// module chunks = 0